export const agentRoles = {
  agent: 1,
  company_admin: 2,
  super_admin: 3,
  // Job roles (multi-value, stored in agent_role_assignment)
  frontline: 10,
  backoffice: 11,
  management: 12,
  other: 13,
};

export const agentRoleLabels: Record<number, string> = {
  1: "Agent",
  2: "Corporate Admin",
  3: "Super Admin",
  10: "Frontline",
  11: "Backoffice",
  12: "Management",
  13: "Other",
};

export const JOB_ROLES = [
  agentRoles.frontline,
  agentRoles.backoffice,
  agentRoles.management,
  agentRoles.other,
] as const;

export type JobRole = (typeof JOB_ROLES)[number];

export const isJobRole = (r: number): boolean =>
  (JOB_ROLES as readonly number[]).includes(r);

export const agentStatus = {
  online: 13,
  offline: 14,
};

export const agentStatusLabels: Record<number, string> = {
  13: "Online",
  14: "Offline",
};
